import React from "react";
import { gql } from "@apollo/client";

import ClarinetMouthpieceField from "components/mouthpiece/ClarinetMouthpieceField";

export default function SolidouClarinet() {
  return <ClarinetMouthpieceField name="solidouClarinet" />;
}

export function isAvailable({ instrument }) {
  return instrument === "clarinet";
}

export const tabName = "solidouClarinet";

export function TabLabel() {
  return (
    <span>
      Créer un bec
      <br />
      <small>(Solidou Clarinet)</small>
    </span>
  );
}

export async function handleSubmit(values, client) {
  return client
    .mutate({
      mutation: gql`
        mutation ($clarinetMouthpiece: ClarinetMouthpieceInput!) {
          CreateClarinetMouthpiece(clarinetMouthpiece: $clarinetMouthpiece) {
            clarinetMouthpiece {
              id
            }
          }
        }
      `,
      variables: {
        clarinetMouthpiece: values.solidouClarinet,
      },
    })
    .then(({ data }) => ({
      type: "clarinetMouthpiece",
      clarinetMouthpiece: data.CreateClarinetMouthpiece.clarinetMouthpiece.id,
    }));
}
